export const VALID_INPUT_FORMATS = [
    'LT',
    'hA',
    'h A',
    'hhA',
    'hh A',
    'HH',
    'HHmm',
    'HH mm',
    'hmmA',
    'hhmmA',
    'hh mm A',
];

export const DISPLAY_FORMAT = 'LT';
